export const BREAKPOINT = 640;

export const STATIC_URL = {
  LOGO: `https://user-images.githubusercontent.com/41494099/86317182-c58a8900-bc69-11ea-9a6e-dfdb1e0141be.png`,
  LOGO_WITHOUT_TEXT: `https://user-images.githubusercontent.com/41494099/87123039-f5b4d600-c2c0-11ea-888c-62d45df7206d.png`,
  MEMBER_ICON: `https://user-images.githubusercontent.com/41494099/87124999-b9837480-c2c4-11ea-8971-0bc9de8b317d.png`,
  MAGNIFYING_GLASS_ICON: `https://user-images.githubusercontent.com/41494099/87172994-10626b80-c310-11ea-99d3-bcc2da2cdb6d.png`,
  GITHUB_ICON: `https://user-images.githubusercontent.com/46309902/88209975-6cbd7780-cc8e-11ea-8205-e8cbb91a887a.png`,
  BLOG_ICON: `https://user-images.githubusercontent.com/46309902/88230840-1829f480-ccae-11ea-8cee-bf92187afbf0.png`,
  SLIDER_IMG1: `https://user-images.githubusercontent.com/52532871/88545310-c7235300-d055-11ea-9d14-c52b2a7db8a1.jpg`,
  SLIDER_IMG2: `https://user-images.githubusercontent.com/52532871/88545367-db675000-d055-11ea-9033-f8fe799f9a3e.jpg`,
  SLIDER_IMG3: `https://user-images.githubusercontent.com/52532871/88545464-fcc83c00-d055-11ea-8ecb-ecb350b620e7.jpg`,
  SLIDER_IMG4: `https://user-images.githubusercontent.com/52532871/148002611-0e18bffe-24ad-42a7-bf52-dffbb93988a6.png`,
  SLIDER_IMG5: `https://user-images.githubusercontent.com/52532871/168413094-f57515ad-7bb4-420f-983e-19cec3f47d77.png`,
  SLIDER_IMG6: `https://user-images.githubusercontent.com/52532871/168413456-59035eda-324f-4440-b05b-e41d5ef38be0.png`,
  KEYWORD_IMG1: `https://user-images.githubusercontent.com/52532871/88550792-0d2fe500-d05d-11ea-99b2-52dd6340afa1.png`,
  KEYWORD_IMG2: `https://user-images.githubusercontent.com/52532871/88550794-0dc87b80-d05d-11ea-92e4-d14f27c21c97.png`,
  KEYWORD_IMG3: `https://user-images.githubusercontent.com/52532871/88550789-0bfeb800-d05d-11ea-8eba-5f8bc3076cbc.png`,
  MBTI_ICON: `https://user-images.githubusercontent.com/46309902/88396371-6a2d6000-cdfd-11ea-959f-565487a586cc.png`,
  GAMBLE_ICON: `https://user-images.githubusercontent.com/46309902/88396558-a9f44780-cdfd-11ea-9731-2458c709ef62.png`,
  PENCIL_ICON: `https://user-images.githubusercontent.com/50616334/88361747-0a12cb80-cdb5-11ea-9545-f5e7be8e9935.png`,
  MAIL_ICON: `https://user-images.githubusercontent.com/46309902/90330808-a1e98b00-dfea-11ea-8916-435647983a3e.png`,
  DEFAULT_PROFILE: `https://user-images.githubusercontent.com/46309902/92148012-dff20600-ee56-11ea-9609-e5046a7e9e9c.png`,
  EDIT_CONFIRM: `https://user-images.githubusercontent.com/46309902/93692736-aea15780-fb31-11ea-9b89-7f49aab82f34.png`,
  FILTER_ICON: `https://user-images.githubusercontent.com/50616334/93690641-d71b5880-fb15-11ea-95fb-f9f106ebb5f9.png`,
};

export const THEME_COLOR = {
  PRIMARY: '#C2201F',
  SECONDARY: '#F19296',
  GRAY: '#F1F1F1',
  GRAYER: '#EDEDED',
};

export const POSTS_PER_PAGE = 20;
export const COMMENTS_PER_PAGE = 50;

export const BOARD_CATEGORY = {
  ALL: '',
  FREE: 'free',
  NOTICE: 'notice',
  INFORMATION: 'info',
  SUGGEST: 'suggest',
  RECRUIT: 'recruit',
};

export interface Activity {
  id: number;
  tag: string;
  title: string;
  published_at: string;
  images: { url: string }[];
  contents: string;
}
